import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistTrafficAccident } from "../../Persist/TrafficAccidentPersister";
import { stageMetaDataTrafficAccident } from "../../Stages/StagesTrafficAccident";
import * as trafficAccidentStages from "../../Stages/StagesTrafficAccident";
import * as caseStatus from "../../LeadStatus/StatusCase";
import * as caseStages from "../../Stages/StagesCase";
import trafficAccidentTransformations from "../FormTransformations/trafficAccidentTransformations";
import { stageFormDefinition as stageFormDefinitionTrafficAccident } from "../FormDefinitions/trafficAccident/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionTrafficAccident } from "../FormDefinitions/trafficAccident/fullFormDefinition";
import { trafficAccidentCaseDetailsSpecialActions } from "../CaseDetailsSpecialActions/trafficAccidentCaseDetailsSpecialActions";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { TrafficAccident } from "../../../types/Products/TrafficLaw/TrafficAccident/TrafficAccident";
import { getProductData } from "./productService";

export const trafficAccident: ProductData<TrafficAccident> = {
  urlPart: "verkehrsunfall",
  lbUrlPart: "verkehrsunfall",
  label: translate("trafficAccident.label"),
  generalLabel: translate("trafficAccident.label"),
  apiUri: "traffic_accidents",
  persist: persistTrafficAccident,
  stages: stageMetaDataTrafficAccident,
  stageConstants: trafficAccidentStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    private: "Selbstzahler",
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\TrafficLaw\\TrafficAccident\\TrafficAccident",
  formTransformations: trafficAccidentTransformations,
  formDefinition: ({ product }) => stageFormDefinitionTrafficAccident(product),
  formDefinitionExternals: ({ product }) => stageFormDefinitionTrafficAccident(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionTrafficAccident(product, currentUser),
  caseDetailsSpecialActions: ({ product }) => trafficAccidentCaseDetailsSpecialActions(product),
  productCategory: "trafficLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.trafficAccident,
};
